module.exports = __webpack_public_path__ + "img/BNB.bf1e86a0.svg";